module.exports = __webpack_public_path__ + "img/madera023.6c2510f2.jpg";